import React, { useEffect, useState } from "react";
import axios from "../../api/axios";
import placeholder from "../../assets/placeholder-cast.jpg";
import { Link } from "react-router-dom";

function Cast({ title, movieId, api }) {
	const [casts, setCast] = useState([]);
	const tvCast = `/tv/${movieId}/credits?api_key=${api}&language=en-US`;
	const movieCast = `/movie/${movieId}/credits?api_key=${api}&language=en-US`;
	const base_url = "https://image.tmdb.org/t/p/original";

	useEffect(() => {
		async function getCast() {
			try {
				let request = await axios.get(movieCast);
				setCast(request.data);
				return request;
			} catch (err) {
				if (err.response) {
					let request = await axios.get(tvCast);
					setCast(request.data);
					return request;
				} else {
					console.log("No Movie found?");
				}
			}
		}
		getCast();
	}, [movieCast, tvCast]);

	if (!casts.cast?.length) return null;

	return (
		<div className="row">
			<div className="row__header">
				<h2 className="row__title">{title}</h2>
			</div>
			<div className="row__posters casts">
				{casts.cast?.map((cast) => (
					<div
						className="cast-member movie-item"
						key={cast.id}
						style={{
							flex: '0 0 150px',
							maxWidth: '150px',
						}}
					>
						<Link to={`/actor/${cast.id}`} style={{ textDecoration: 'none' }}>
							<div style={{ overflow: 'hidden', borderRadius: 'var(--radius-md) var(--radius-md) 0 0' }}>
								<img
									src={
										cast?.profile_path
											? `${base_url}${cast?.profile_path}`
											: placeholder
									}
									alt={cast?.name || cast?.character}
									style={{
										width: '100%',
										height: '225px',
										objectFit: 'cover',
										objectPosition: 'center',
									}}
								/>
							</div>
							<div style={{
								padding: 'var(--space-3)',
								textAlign: 'center',
							}}>
								<h3 style={{
									color: 'var(--text-primary)',
									fontSize: 'var(--text-sm)',
									fontWeight: 'var(--font-semibold)',
									marginBottom: '2px',
									whiteSpace: 'nowrap',
									overflow: 'hidden',
									textOverflow: 'ellipsis',
								}}>
									{cast?.name || cast?.original_name}
								</h3>
								<div style={{
									color: 'var(--text-muted)',
									fontSize: 'var(--text-xs)',
									whiteSpace: 'nowrap',
									overflow: 'hidden',
									textOverflow: 'ellipsis',
								}}>
									{cast?.character}
								</div>
							</div>
						</Link>
					</div>
				))}
			</div>
		</div>
	);
}

export default Cast;
